import * as React from 'react';
import { graphql } from 'gatsby';
import {
    BuilderComponent,
    Builder,
} from '@builder.io/react';
import { Helmet } from 'react-helmet';
import Link from '../components/Link/Link';
import '@builder.io/widgets';


const ShopPage = (props) => {

    const {
        data: { allBuilderModels },
        model
    } = props
    const content = allBuilderModels?.template[0]?.content;

    const data = { ...props };
    delete data.data;
    delete data.model;
    delete data.pageResources;

    return <BuilderComponent
        data={{ props: data }}
        content={content}
        renderLink={Link}
        model='template' />;
};

export default ShopPage;

